var kulczynskiD = require('./../distances/kulczynski');

module.exports = function kulczynski(a, b) {
    return 1 / kulczynskiD(a, b);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/similarities/kulczynski.js
 ** module id = 110
 ** module chunks = 0
 **/